import React, { useRef } from "react";
import * as Icons from "lucide-react";

// Étape optionnelle (jamais bloquante) : une identité visuelle n'est souvent
// pas prête au jour 1 du client.
export default function IdentityStep({ logos, onUpload, onDelete, uploading, firstFieldRef }) {
  const fileRef = useRef(null);
  const canAddMore = (logos || []).length < 3;

  const handleFile = (e) => {
    const f = e.target.files?.[0];
    if (f) onUpload(f);
    e.target.value = "";
  };

  return (
    <div>
      <p className="text-xs text-marine/80 mb-3">Optionnel — vous pourrez ajouter votre logo plus tard si besoin.</p>
      <div className="grid grid-cols-3 gap-3 mb-3">
        {(logos || []).map((l) => (
          <div key={l.path} className="relative border border-marine/15 rounded-sm p-2 bg-sable">
            <button type="button" onClick={() => onDelete(l.path)} aria-label={`Supprimer ${l.label || l.name}`}
              className="absolute -top-2 -right-2 w-5 h-5 rounded-full bg-rouge text-white flex items-center justify-center text-xs">
              <Icons.X size={16} aria-hidden="true" />
            </button>
            <div className="text-xs text-marine/80 truncate text-center">{l.label || l.name}</div>
          </div>
        ))}
      </div>
      {canAddMore && (
        <>
          <input ref={fileRef} id="onb-logo-input" type="file" accept="image/*" className="hidden" onChange={handleFile} />
          <button type="button" ref={firstFieldRef} onClick={() => fileRef.current?.click()} disabled={uploading}
            data-testid="onboarding-logo-upload"
            className="w-full border-2 border-dashed border-marine/30 rounded-sm py-5 text-sm text-marine hover:bg-creme transition-colors flex flex-col items-center gap-1 disabled:opacity-50">
            <Icons.Upload size={16} aria-hidden="true" /> {uploading ? "Envoi en cours…" : "Ajouter un logo"}
          </button>
        </>
      )}
    </div>
  );
}
